module.exports = __webpack_public_path__ + "media/launchable-detail3.a9db48c2.webm";